import React from 'react'
import LikeButton from '../LikeButton'
import Comments from '../Comments'
import { getDisplayAvatar } from '../../utils/profileManager'

const SocialSection = ({ event, user }) => {
  if (!event.createdBy) return null

  return (
    <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-8">
      <UserInfo event={event} user={user} />
      <SocialActions event={event} user={user} />
      <CommentsSection event={event} user={user} />
    </div>
  )
}

const UserInfo = ({ event, user }) => (
  <div className="mb-6">
    <div className="flex items-center gap-3 mb-4">
      <UserAvatar user={event.createdBy} />
      <UserDetails event={event} user={user} />
    </div>
  </div>
)

const UserAvatar = ({ user }) => {
  const avatar = getDisplayAvatar(user)

  return (
    <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-semibold">
      {avatar.type === 'picture' ? (
        <img
          src={avatar.src}
          alt={user.username || user.fullName || 'User'}
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        <span className="text-lg">{avatar.icon}</span>
      )}
    </div>
  )
}

const UserDetails = ({ event, user }) => (
  <div>
    <p className="text-white font-medium">
      {event.createdBy?._id === user?.id ? 'Your Event' : `${event.createdBy?.username || event.createdBy?.fullName || 'Unknown User'}'s Event`}
    </p>
    <PrivacyIndicator privacy={event.privacy} />
  </div>
)

const PrivacyIndicator = ({ privacy }) => (
  <p className="text-gray-400 text-sm">
    {privacy === 'public' && '🌍 Public Event'}
    {privacy === 'friends' && '👥 Friends Only'}
    {privacy === 'private' && '🔒 Private Event'}
  </p>
)

const SocialActions = ({ event, user }) => (
  <div className="flex items-center gap-4 mb-6">
    <LikeButton
      eventId={event._id}
      initialLikes={event.likes || []}
      currentUserId={user?.id}
    />
  </div>
)

const CommentsSection = ({ event, user }) => (
  <Comments
    eventId={event._id}
    initialComments={event.comments || []}
    currentUserId={user?.id}
    eventOwnerId={event.createdBy?._id}
  />
)

export default SocialSection